import { companyHeaderLines, companyLogo } from "./companyProfile";

/**
 * Testata dei documenti generati, condivisa da preventivi, ordini e DDT.
 *
 * Prima ogni generatore disegnava la propria, con lo stesso codice copiato:
 * il logo a sinistra e le righe dell'azienda allineate a destra. Tenerla in un
 * punto solo evita che i documenti divergano quando se ne modifica uno.
 */

/** Ingombro verticale della testata, in millimetri. */
export const HEADER_HEIGHT = 48;

const LOGO_WIDTH = 60;
const LOGO_HEIGHT = 24;

/**
 * Disegna la testata e restituisce la coordinata Y da cui proseguire.
 *
 * Il logo arriva dal profilo azienda come data URL: se non è configurato, o se
 * jsPDF non riesce a incorporarlo, il documento prosegue con le sole righe di
 * testo. Un documento senza logo è accettabile, un documento che non si genera
 * no.
 */
export function drawDocumentHeader(doc, { pageWidth, marginX = 10, y = 10 }) {
  const logo = companyLogo();
  if (logo) {
    try {
      doc.addImage(
        logo.dataUrl,
        logo.format,
        marginX - 5,
        y,
        LOGO_WIDTH,
        LOGO_HEIGHT
      );
    } catch {
      // Immagine non incorporabile: si continua senza.
    }
  }

  doc.setFontSize(9).setFont("helvetica", "normal");
  companyHeaderLines().forEach((text, i) => {
    const x = pageWidth - marginX - doc.getTextWidth(text);
    doc.text(text, x, y + 5 + i * 4);
  });

  return y + HEADER_HEIGHT;
}
